import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c39e1c6e"
import script from "./App.component.ts?vue&type=script&lang=js&external"
export * from "./App.component.ts?vue&type=script&lang=js&external"
import style0 from "./App.vue?vue&type=style&index=0&id=c39e1c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports